import {Logger} from "platform/logger/Logger";

const logger: Logger = Logger.Of("ServiceWorkerRegistration");

interface SWConfig {
    swUrl: string;
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
}

function register(config: SWConfig) {
    if ("serviceWorker" in navigator) {
        const publicUrl = new URL(
            (process.env.PUBLIC_URL as string) || "",
            window.location.href
        );

        // Service worker must be served from the same origin
        if (publicUrl.origin !== window.location.origin) {
            return;
        }

        checkValidServiceWorker(config);
        navigator.serviceWorker.ready.then(() => {
            logger.info("Service worker ready.");
        });

    }
}

function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                logger.error(error.message);
            });
    }
}

function registerValidSW(config: SWConfig) {
    navigator.serviceWorker
        .register(config.swUrl)
        .then((registration) => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) return;

                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            // Updated content is available, user should refresh
                            logger.info("New service worker content is available; please refresh.");
                            if (config?.onUpdate) {
                                config.onUpdate(registration);
                            }
                        } else {
                            logger.info("Service worker registered successfully.");
                            if (config?.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch((error) => {
            logger.error("Error during service worker registration:", error);
        });
}

function checkValidServiceWorker(config?: SWConfig) {
    fetch(config.swUrl, {
        headers: {"Service-Worker": "script"},
    })
        .then((response) => {
            const contentType = response.headers.get("content-type");
            if (
                response.status === 404 ||
                (contentType != null && contentType.indexOf("javascript") === -1)
            ) {
                // No service worker found. Unregister and reload the page.
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
            } else {
                // Service worker found, proceed with registration
                registerValidSW(config);
            }
        })
        .catch(() => {
            logger.info(
                "No internet connection found. App is running in offline mode."
            );
        });
}

export const ServiceWorkerRegistration = {register, unregister};
